export let ApiLoginWarning = /*#__PURE__*/function (ApiLoginWarning) {
  ApiLoginWarning["EMAIL_VERIFICATION"] = "email verification";
  ApiLoginWarning["PHONE_VERIFICATION"] = "Phone";
  ApiLoginWarning["REGISTER_ACTION"] = "register-patient";
  return ApiLoginWarning;
}({});